<template>
  <footer
    class="footer"
    :class="{ [`footer-${type}`]: type }"
    :data-background-color="backgroundColor"
  >
    <!-- <div class="container">
      <nav>
        <ul>
          <li>
            <a href="/">
              Home
            </a>
          </li>
          <li>
            <a href="/about">
              About
            </a>
          </li>
          <li>
            <a href="/categories">
              Products
            </a>
          </li>
          <li>
            <a href="/faqs">
              Faqs
            </a>
          </li>
          <li>
            <a href="/contact">
              Contact
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright">
        &copy; {{ year }}, Asiong's Industrial Products
      </div>
    </div> -->
    <div class="more-footer-stuff">
      <div class="custom-footer-container">
        <div class="footer-texts">
          <div class="links-header">
            <!-- <i class="material-icons">inventory</i> -->
            <a href="/contact">
              <h4><strong>Contact</strong></h4>
            </a>
          </div>
          <vue-simple-markdown :source=footer.footer_contact_info style="color: #eeeeee !important;"></vue-simple-markdown>
          <a target="_blank" href="https://g.page/asiongs-industrial-products?share">View on Map</a>

        </div>
        <div class="site-map-main">
          <div class="links-header">
            <!-- <i class="material-icons">inventory</i> -->
            <a href="/">
              <h4><strong>Asiong's</strong></h4>  
            </a>
          </div>
          <a href="/"><h5>Home</h5></a>
          <a href="/about"><h5>About</h5></a>
          <a href="/products"><h5>Products</h5></a>
          <a href="/faqs"><h5>FAQ's</h5></a>
          <a href="/contact"><h5>Contact</h5></a>
        </div>
        <div class="categories-link">
          <div class="links-header">
            <!-- <i class="material-icons">inventory</i> -->
            <a href="/products">
              <h4><strong>Products</strong></h4>
            </a>
          </div>
          
          <div class="category-links">
            <div v-for="category in categories" :key="category.id">
              <router-link :to="'/products/' + category.slug">
                <p>{{category.Name}}</p>
              </router-link>
            </div>
          </div>
          
         
        </div>
        

        <div class="socmed-links">
          <md-button class="md-simple md-just-icon md-round" href="https://www.facebook.com/asiongsindustrial" target="_blank"
            ><img :src=facebook_icon></md-button
          >
          <md-button class="md-simple md-just-icon md-round" href="https://www.linkedin.com/company/asiongs-industrial-products/" target="_blank"
            ><img :src=linkedin_icon></md-button
          >
          <md-button class="md-simple md-just-icon md-round" href="https://www.youtube.com/channel/UCoSdlF4ap9TLmEui0o5aMKA" target="_blank"
            ><img :src=youtube_icon></md-button
          >
        </div>
      </div>
      <div class="copyright">
        <div class="">
          &copy; {{ year }}, Asiong's Industrial Products
        </div>
        <div>
          Developed by <a href="https://www.linkedin.com/in/john-arvin-enriquez" target="_blank">Arvin Enriquez</a>
        </div>
        
      </div>
      
    </div>
  </footer>
</template>
<script>
import axios from "axios";
export default {
  props: {
    backgroundColor: String,
    type: String,
    facebook_icon: {
      type: String,
      default: require("@/assets/facebook-4-24.png")
    },
    linkedin_icon: {
      type: String,
      default: require("@/assets/linkedin-4-24.png")
    },
    youtube_icon: {
      type: String,
      default: require("@/assets/youtube-4-24.png")
    }
  },
  data() {
    return {
      year: new Date().getFullYear(),
      categories: [],
      footer: {}
    };
    
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/categories?_sort=Name:ASC", {}).then(
      (response) => {
        this.categories = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
    axios.get("https://strapi-asiongs.herokuapp.com/footer", {}).then(
      (response) => {
        this.footer = response.data;
      },
      (error) => {
        // console.log(error);
      }
    );
  }
};
</script>
<style lang="scss" scoped>
footer{
  padding: 0;
  margin-top: -96px;
  background-color: #182e5a;
}
.more-footer-stuff{
  margin-top: 128px;
  margin: auto;
  max-width: 1440px;
  padding: 24px 24px;
  padding-bottom: 0px;
  // background-color: #182e5a;

  .custom-footer-container{
    margin-top: 128px;
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
    gap: 24px;
    // display: flex;
    // flex-flow: row wrap;
    // justify-content: space-between;
    @media only screen and (min-width: 1440px) {
      grid-template-columns: 3fr 1fr 2fr 1fr;
    }

    @media only screen and (max-width: 1439px) {
      grid-template-columns: repeat(auto-fit, minmax(240px , 1fr));
    }

    a{
      color: #acacac;
      transition: 0.2s;

      &:hover{
        color: #eeeeee !important;
      }
    }
    
    .links-header{
      // border-bottom: 1px solid #b6b6b6;
      margin-bottom: 16px;
      a{
        color: #eeeeee;
        transition: 0.2s;

        &:hover{
          color: #acacac !important;
        }
      }
    }

    .site-map-main{
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      // min-width: 240px;
      h5{
        margin: 0;
        margin-bottom: 16px;
      }
    }

    .categories-link{
      // min-width: 380px;
      .category-links{
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(180px , 1fr));
        // grid-template-columns: 1fr 1fr;
        grid-auto-flow: row;
        gap: 8px;
        
        p{
          margin: 8px 0px;
        }
      }
    }

    .footer-texts{
      // padding: 0px 24px;
      div{
        color: #eeeeee !important;
         a{
          color: #eeeeee !important;
        }
      }

      .markdown-body{
        a{
          color: #eeeeee !important;
        }
      }
    }
    
    .socmed-links{
      display: flex;
      flex-direction: row;
      justify-content: center;
      a{
        margin: 8px;
      }
    }
  }

  .copyright{
    width: 100%;
    background-color: #182e5a;
    margin: 0;
    color: white;
    // border-radius: 8px;
    margin-top: 16px;
    border-top: 1px solid #b6b6b6;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    a{
      color: #eeeeee;
      text-decoration: underline;
      &:hover{
        color: #acacac !important;
      }
    }
  }
}
</style>
